import { Label } from 'bitmovin-player-ui';
export function createAdLabel(npoplayer) {
    npoplayer.uiComponents.adlabel = undefined;
    const adLabel = new Label({ text: '', cssClass: 'adLabel', hidden: true });
    npoplayer.uiComponents.adlabel = adLabel;
    return adLabel;
}
